import { render, staticRenderFns } from "./EventPublishingDialog.vue?vue&type=template&id=8a80bcae&scoped=true"
import script from "./EventPublishingDialog.vue?vue&type=script&lang=js"
export * from "./EventPublishingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80bcae",
  null
  
)

export default component.exports